import React, { Component } from 'react';
import getLabel from '../services/LinkagesDataLayer/labels';

function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    return `rgb(${r}, ${g}, ${b})`;
}

class RendaIbgeLegend extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    formatData = (data) => {
        let dataType = this.props.mapa_coropetico_current_showing?.config?.dado_type;

        let formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        let doubleFormatter = new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            maximumFractionDigits: 2
        });

        if (dataType === 'currency') {
            return formatter.format(data);
        }

        if (dataType === 'percentage') {
            return formatter.format(data).replace("R$", "") + '%';
        }

        if (dataType === 'double') {
            return doubleFormatter.format(data);
        }

        return doubleFormatter.format(data);
    }

    render() {

        let colorRanges = this.props.colorRanges;
        let title = this.props.title;

        if(this.props.datalayerColorProperty){
            let colorProperty = this.props.datalayerColorProperty;

            if( colorProperty?.includes("|"))
            {
                colorProperty = colorProperty.split("|")[1];
            }


            title = `${title} - ${getLabel(colorProperty)}`;
        }

        return (<React.Fragment>
            <table className="table table-striped table-condensed legenda-mapa">
                <thead>
                    <tr>
                        <th scope="col" colSpan="2" style={{ textAlign: 'center' }}>

                            <span className="font-weight-bold text-center"
                                style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}>
                                {title}
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {colorRanges?.map((item, index) => (<tr key={index} style={styles.legend}>
                        <td style={{ ...styles.legend, width: '15%', backgroundColor: hexToRGB(item.color, '0.9') }}>
                            <div style={{ width: '13px', height: '13px' }}></div>
                        </td>
                        <td style={styles.legend}>
                            {colorRanges.length !== 1 && <React.Fragment>
                                {item.max !== Infinity && <>
                                    {this.formatData(item.min)}&nbsp;- {this.formatData(item.max)}
                                </>}
                                {item.max === Infinity && <>
                                    Acima de {this.formatData(item.min)}
                                </>}
                            </React.Fragment>}

                            {colorRanges.length === 0 && <React.Fragment>
                                &nbsp;
                            </React.Fragment>}
                        </td>
                    </tr>))}
                </tbody>
            </table>

            <hr />
            {this.props.datalayerName !== 'dutovias' && <React.Fragment>
                <button className="btn btn-default btn-sm btn-block" onClick={this.props.openModalLegendas}>
                    Customizar Faixas
                </button>
            </React.Fragment>}
        </React.Fragment>
        );

    }
}

const styles = {
    legend: {
        padding: '5px',
        margin: '4px',
    }
}


export default RendaIbgeLegend;
